<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>

.osfQuizError {
    position: absolute;
    background: #C8643B;
    color: white;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.osfQuizError p {
    display: flex;
    flex-wrap: wrap;
    font-size: 0.875rem;
    text-transform: uppercase;
    max-width: 50%;
}
</style>

<template>
    <div>
        <!-- Error message container -->
        <div class="osfQuizError">
            <p>{{ errorMessage }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error',
    computed: {
        errorMessage: function () {
            return this.$store.state.errorMessage;
        }
    }
};
</script>
